(function() {
  if (!document.body.classList.contains('template-collection')) return;

  /* ============================================================
     MOSSEN — Filtres collection (panneau pleine largeur)
     ============================================================ */

  if (!document.getElementById('mossen-filters-styles')) {
    const style = document.createElement('style');
    style.id = 'mossen-filters-styles';
    style.textContent = `
      /* ---------- Barre de pills ---------- */
      .mossen-filter-pills {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 16px 0;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
      }
      .mossen-filter-pills::-webkit-scrollbar { display: none; }

      .mossen-pills-left,
      .mossen-pills-right { display: flex; gap: 8px; flex-shrink: 0; }

      /* Effet Liquid Glass */
      .mossen-filter-pill {
        padding: 9px 16px;
        border: 1px solid rgba(0, 0, 0, 0.08); 
        border-radius: 24px;
        background: rgba(255, 255, 255, 0.5); 
        backdrop-filter: blur(12px) saturate(180%);
        -webkit-backdrop-filter: blur(12px) saturate(180%);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04), inset 0 1px 2px rgba(255, 255, 255, 0.8), inset 0 -1px 2px rgba(0, 0, 0, 0.02);
        font-size: 11px;
        font-weight: 500;
        letter-spacing: .1em;
        text-transform: uppercase;
        text-decoration: none;
        color: #111;
        cursor: pointer;
        white-space: nowrap;
        flex-shrink: 0;
        transition: all .3s ease;
      }
      .mossen-filter-pill:hover {
        background: rgba(255, 255, 255, 0.8);
        border-color: rgba(0, 0, 0, 0.12);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08), inset 0 1px 3px rgba(255, 255, 255, 1);
        transform: translateY(-1px);
      }

      .mossen-pill-toggle { display: inline-flex; align-items: center; gap: 8px; }
      .mossen-pill-toggle .mossen-caret {
        width: 7px; height: 7px;
        border-right: 1px solid currentColor;
        border-bottom: 1px solid currentColor;
        transform: translateY(-2px) rotate(45deg);
        transition: transform .3s ease;
      }
      .mossen-pill-toggle.is-open {
        background: rgba(17, 17, 17, 0.75);
        color: #fff;
        border: 1px solid rgba(17, 17, 17, 0.8);
        backdrop-filter: blur(12px) saturate(180%);
        -webkit-backdrop-filter: blur(12px) saturate(180%);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15), inset 0 1px 3px rgba(255, 255, 255, 0.2);
      }
      .mossen-pill-toggle.is-open .mossen-caret { transform: translateY(1px) rotate(-135deg); }

      /* ---------- Panneau pleine largeur ---------- */
      .mossen-panel {
        position: fixed;
        left: 0; right: 0;
        background: #fff;
        border-bottom: 1px solid #ededed;
        z-index: 100000;
        overflow: hidden;
        animation: mossenPanelIn .38s cubic-bezier(.22,.61,.36,1) both;
      }
      .mossen-panel.is-closing { animation: mossenPanelOut .24s ease both; }

      @keyframes mossenPanelIn {
        from { opacity: 0; transform: translateY(-14px); }
        to   { opacity: 1; transform: translateY(0); }
      }
      @keyframes mossenPanelOut {
        from { opacity: 1; transform: translateY(0); }
        to   { opacity: 0; transform: translateY(-10px); }
      }

      .mossen-panel__inner {
        max-width: 1400px;
        margin: 0 auto;
        padding: 26px 40px 24px;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      }

      .mossen-panel__head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        margin: 0 0 22px;
      }
      .mossen-panel__label {
        font-size: 10px;
        letter-spacing: .18em;
        text-transform: uppercase;
        color: #9a9a9a;
        margin: 0;
      }
      .mossen-panel__close {
        width: 32px; height: 32px;
        border: none;
        background: none;
        cursor: pointer;
        position: relative;
        flex-shrink: 0;
        margin: -8px -8px -8px 0;
        transition: opacity .2s ease;
      }
      .mossen-panel__close:hover { opacity: .55; }
      .mossen-panel__close::before,
      .mossen-panel__close::after {
        content: '';
        position: absolute;
        top: 50%; left: 50%;
        width: 15px; height: 1px;
        background: #111;
      }
      .mossen-panel__close::before { transform: translate(-50%,-50%) rotate(45deg); }
      .mossen-panel__close::after  { transform: translate(-50%,-50%) rotate(-45deg); }

      .mossen-panel__footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        max-width: 1400px;
        margin: 0 auto;
        padding: 16px 40px;
        border-top: 1px solid #f0f0f0;
      }
      .mossen-reset, .mossen-apply {
        font-size: 10px;
        letter-spacing: .16em;
        text-transform: uppercase;
        cursor: pointer;
        border: none;
        background: none;
        transition: opacity .2s ease;
      }
      .mossen-reset { color: #9a9a9a; padding: 6px 0; }
      .mossen-reset:hover { color: #111; }
      .mossen-apply {
        background: #111; color: #fff;
        padding: 13px 34px;
      }
      .mossen-apply:hover { opacity: .82; }

      /* ---------- Couleurs ---------- */
      .mossen-colors {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(78px, 1fr));
        gap: 26px 14px;
      }
      .mossen-color { text-align: center; cursor: pointer; }
      .mossen-color__dot {
        width: 34px; height: 34px;
        border-radius: 50%;
        margin: 0 auto 9px;
        box-shadow: 0 0 0 1px rgba(0,0,0,.08);
        transition: box-shadow .25s ease, transform .25s ease;
      }
      .mossen-color:hover .mossen-color__dot { transform: scale(1.08); }
      .mossen-color.active .mossen-color__dot {
        box-shadow: 0 0 0 1px #fff, 0 0 0 2px #111;
      }
      .mossen-color__name {
        font-size: 10px;
        letter-spacing: .08em;
        text-transform: uppercase;
        color: #6d6d6d;
        transition: color .2s ease;
      }
      .mossen-color.active .mossen-color__name { color: #111; }

      /* ---------- Filtres actifs ---------- */
      .mossen-status {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        padding: 0 0 16px;
      }
      .mossen-status__count {
        font-size: 10px;
        letter-spacing: .16em;
        text-transform: uppercase;
        color: #9a9a9a;
      }
      .mossen-chip {
        display: inline-flex;
        align-items: center;
        gap: 9px;
        padding: 7px 12px;
        border: 1px solid #111;
        background: #fff;
        border-radius: 2px;
        font-size: 10px;
        letter-spacing: .1em;
        text-transform: uppercase;
        color: #111;
        cursor: pointer;
      }
      .mossen-chip i {
        width: 8px; height: 8px;
        position: relative;
        flex-shrink: 0;
      }
      .mossen-chip i::before, .mossen-chip i::after {
        content: '';
        position: absolute;
        top: 50%; left: 0;
        width: 8px; height: 1px;
        background: currentColor;
      }
      .mossen-chip i::before { transform: rotate(45deg); }
      .mossen-chip i::after  { transform: rotate(-45deg); }

      .mossen-note {
        font-size: 12px;
        color: #9a9a9a;
        margin: 0;
      }

      /* ---------- Prix ---------- */
      .mossen-price { max-width: 420px; padding: 4px 0 8px; }
      .mossen-price__values {
        display: flex;
        justify-content: space-between;
        font-size: 11px;
        letter-spacing: .1em;
        color: #111;
      }
      .mossen-price__track {
        position: relative;
        height: 2px;
        background: #e4e4e4;
        margin: 26px 9px 10px;
      }
      .mossen-price__fill {
        position: absolute;
        top: 0; height: 2px;
        background: #111;
      }
      .mossen-price__track input[type="range"] {
        position: absolute;
        top: -10px; left: -9px;
        width: calc(100% + 18px);
        height: 22px;
        margin: 0;
        background: none;
        pointer-events: none;
        -webkit-appearance: none;
        appearance: none;
      }
      .mossen-price__track input[type="range"]:focus { outline: none; }
      .mossen-price__track input[type="range"]::-webkit-slider-thumb {
        -webkit-appearance: none;
        pointer-events: auto;
        width: 16px; height: 16px;
        border-radius: 50%;
        background: #fff;
        border: 1px solid #111;
        cursor: grab;
      }
      .mossen-price__track input[type="range"]::-moz-range-thumb {
        pointer-events: auto;
        width: 16px; height: 16px;
        border-radius: 50%;
        background: #fff;
        border: 1px solid #111;
        cursor: grab;
      }

      /* ---------- État vide ---------- */
      .mossen-empty { padding-bottom: 60px; }
      .mossen-empty__title {
        font-size: 14px;
        color: #111;
        margin: 34px 0 6px;
      }
      .mossen-empty__sub {
        font-size: 13px;
        color: #9a9a9a;
        margin: 0 0 40px;
      }

      .mossen-report {
        border: 1px solid #ededed;
        max-width: 620px;
      }
      .mossen-report__head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        padding: 20px 22px;
      }
      .mossen-report__title {
        font-size: 12px;
        color: #111;
        margin: 0 0 4px;
      }
      .mossen-report__sub {
        font-size: 10px;
        letter-spacing: .14em;
        text-transform: uppercase;
        color: #9a9a9a;
        margin: 0;
      }
      .mossen-report__toggle {
        flex-shrink: 0;
        padding: 11px 22px;
        border: 1px solid #111;
        background: #fff;
        font-size: 10px;
        letter-spacing: .14em;
        text-transform: uppercase;
        color: #111;
        cursor: pointer;
        transition: background .2s ease, color .2s ease;
      }
      .mossen-report__toggle:hover { background: #111; color: #fff; }

      .mossen-report__body {
        padding: 4px 22px 22px;
        border-top: 1px solid #f0f0f0;
      }
      .mossen-report__field { border: none; padding: 0; margin: 20px 0 0; }
      .mossen-report__field legend,
      .mossen-lbl {
        display: block;
        font-size: 10px;
        letter-spacing: .14em;
        text-transform: uppercase;
        color: #9a9a9a;
        padding: 0;
        margin-bottom: 12px;
      }
      .mossen-check {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        font-size: 12px;
        color: #111;
        margin-bottom: 9px;
        cursor: pointer;
      }
      .mossen-check input { margin: 2px 0 0; accent-color: #111; flex-shrink: 0; }

      .mossen-input {
        width: 100%;
        padding: 12px 14px;
        border: 1px solid #e4e4e4;
        border-radius: 2px;
        background: #fff;
        font-size: 13px;
        color: #111;
        font-family: inherit;
        box-sizing: border-box;
        transition: border-color .2s ease;
      }
      .mossen-input:focus { outline: none; border-color: #111; }
      .mossen-textarea { resize: vertical; min-height: 90px; }

      .mossen-report__send {
        margin-top: 22px;
        padding: 13px 30px;
        border: none;
        background: #111;
        color: #fff;
        font-size: 10px;
        letter-spacing: .16em;
        text-transform: uppercase;
        cursor: pointer;
        transition: opacity .2s ease;
      }
      .mossen-report__send:hover { opacity: .82; }

      .mossen-report__note {
        margin: 14px 0 0;
        font-size: 12px;
        color: #9a9a9a;
      }
      .mossen-report__note a { color: #111; }
      .mossen-report__done {
        margin: 22px 0;
        font-size: 13px;
        color: #111;
      }

      /* ---------- Voile ---------- */
      #mossen-backdrop {
        position: fixed; inset: 0;
        background: rgba(17,17,17,.22);
        z-index: 99999;
        animation: mossenFadeIn .38s ease both;
      }
      #mossen-backdrop.is-closing { animation: mossenFadeOut .24s ease both; }
      @keyframes mossenFadeIn  { from { opacity: 0 } to { opacity: 1 } }
      @keyframes mossenFadeOut { from { opacity: 1 } to { opacity: 0 } }

      /* ---------- Mobile ---------- */
      @media (max-width: 749px) {
        .mossen-filter-pills { gap: 6px; padding: 12px 0; }
        .mossen-pills-left, .mossen-pills-right { gap: 6px; }
        .mossen-filter-pill { padding: 7px 12px; font-size: 10px; letter-spacing: .08em; }

        .mossen-panel__inner { padding: 18px 18px 18px; }
        .mossen-panel__head { margin-bottom: 18px; }
        .mossen-panel__footer { padding: 13px 18px; }

        .mossen-colors { grid-template-columns: repeat(auto-fill, minmax(62px, 1fr)); gap: 20px 8px; }
        .mossen-color__dot { width: 30px; height: 30px; margin-bottom: 7px; }
        .mossen-color__name { font-size: 9px; }

        .mossen-apply { padding: 12px 26px; }

        .mossen-empty__title { font-size: 13px; margin-top: 26px; }
        .mossen-empty__sub { margin-bottom: 30px; }
        .mossen-report__head { flex-direction: column; align-items: flex-start; gap: 14px; padding: 18px; }
        .mossen-report__toggle { width: 100%; }
        .mossen-report__body { padding: 4px 18px 18px; }
        .mossen-report__send { width: 100%; }
      }

      @media (prefers-reduced-motion: reduce) {
        .mossen-panel, #mossen-backdrop { animation: none !important; }
      }

      /* ---------- Ordinateur : barre de filtres masquée ---------- */
      @media (min-width: 750px) {
        #mossen-filter-pills { display: none !important; }
      }
    `;
    document.head.appendChild(style);
  }

  /* ---------- Données ---------- */

  const PARAMS = { colors: 'mf-couleur', price: 'mf-prix' };
  const LABELS = { colors: 'Couleur', price: 'Prix' };

  /* ============================================================
     Filtrage côté navigateur
     ============================================================ */

  const norm = s => (s || '').toString().toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  let catalogue = null;

  function currentHandle() {
    return (window.location.pathname.match(/^\/collections\/([^/]+)/) || [, 'all'])[1];
  }

  function loadFromTemplate(handle) {
    return fetch('/collections/' + handle + '?view=filters')
      .then(r => r.ok ? r.text() : Promise.reject())
      .then(t => {
        const rows = JSON.parse(t.trim());
        const map = {};
        rows.forEach(p => {
          map[p.h] = {
            text: norm(p.t),
            couleur: new Set((p.c || '').split('|').filter(Boolean).map(norm)),
            pmin: parseFloat(p.pmin) || 0,
            pmax: parseFloat(p.pmax) || 0
          };
        });
        if (!Object.keys(map).length) throw new Error('vide');
        return map;
      });
  }

  function loadFromJson(handle) {
    return fetch('/collections/' + handle + '/products.json?limit=250')
      .then(r => r.json())
      .then(d => {
        const map = {};
        (d.products || []).forEach(p => {
          const text = norm([
            p.title, p.body_html ? p.body_html.replace(/<[^>]*>/g, ' ') : '',
            p.product_type, (p.tags || []).join(' ')
          ].join(' '));

          const opts = {};
          (p.options || []).forEach((o, i) => { opts['option' + (i + 1)] = norm(o.name); });

          const values = { couleur: new Set() };
          (p.variants || []).forEach(v => {
            ['option1', 'option2', 'option3'].forEach(k => {
              if (!v[k]) return;
              const name = opts[k] || '';
              if (/couleur|color|coloris/.test(name)) values.couleur.add(norm(v[k]));
            });
          });

          const prices = (p.variants || []).map(v => parseFloat(v.price)).filter(n => n > 0);
          map[p.handle] = {
            text, couleur: values.couleur,
            pmin: prices.length ? Math.min(...prices) : 0,
            pmax: prices.length ? Math.max(...prices) : 0
          };
        });
        return map;
      })
      .catch(() => ({}));
  }

  function loadCatalogue() {
    if (catalogue) return catalogue;
    const handle = currentHandle();
    catalogue = loadFromTemplate(handle).catch(() => loadFromJson(handle));
    return catalogue;
  }

  function hasWord(text, term) {
    const t = norm(term);
    if (!t) return false;
    const esc = t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp('\\b' + esc + '(e|s|es|x)?\\b').test(text);
  }

  const COLOR_WORDS = {
    noir:     ['noir'],
    blanc:    ['blanc', 'ecru', 'ivoire'],
    beige:    ['beige', 'sable'],
    camel:    ['camel', 'fauve'],
    gris:     ['gris', 'anthracite'],
    marine:   ['marine'],
    bleu:     ['bleu', 'azur'],
    rose:     ['rose'],
    rouge:    ['rouge'],
    bordeaux: ['bordeaux', 'lie de vin'],
    vert:     ['vert'],
    marron:   ['marron', 'chocolat', 'brun'],
    kaki:     ['kaki'],
    or:       ['dore', 'or'],
    argent:   ['argent', 'argente'],
    taupe:    ['taupe']
  };

  const HEX = {
    noir: '#111111', blanc: '#FFFFFF', ecru: '#F2EBDD', ivoire: '#FAF5EA', creme: '#F3EADA',
    beige: '#C8AD8F', sable: '#D9C7A7', taupe: '#6B5D54', camel: '#C19A6B', fauve: '#B5651D',
    marron: '#6F4E37', chocolat: '#4B3621', brun: '#5C4033', kaki: '#9B8C5C', olive: '#6B6B3A',
    vert: '#1A3D1A', menthe: '#A8D5BA', emeraude: '#046307',
    bleu: '#0066CC', marine: '#1F305E', azur: '#4A90D9', ciel: '#A9CCE3',
    turquoise: '#30D5C8', denim: '#3B5998',
    violet: '#6A0DAD', lilas: '#C8A2C8', mauve: '#B784A7',
    rose: '#E8B4C8', fuchsia: '#C74375', corail: '#F88379',
    rouge: '#C0392B', bordeaux: '#6B1C1C', orange: '#E2725B',
    moutarde: '#D4A017', jaune: '#F2D544', or: '#D4AF37', dore: '#D4AF37',
    argent: '#C0C0C0', argente: '#C0C0C0', gris: '#999999', anthracite: '#4A4A4A'
  };

  function hexFor(name) {
    const v = norm(name);
    if (HEX[v]) return HEX[v];
    const words = v.split(/[\s-]+/).filter(Boolean);
    for (let i = words.length - 1; i >= 0; i--) if (HEX[words[i]]) return HEX[words[i]];
    return null;
  }

  const cap = s => s.charAt(0).toUpperCase() + s.slice(1);

  function availableColors(data) {
    const entries = Object.values(data);
    const found = new Map();

    entries.forEach(e => e.couleur.forEach(v => {
      if (v && !found.has(v)) found.set(v, cap(v));
    }));

    Object.keys(COLOR_WORDS).forEach(base => {
      if (found.has(base)) return;
      if (entries.some(e => (COLOR_WORDS[base] || [base]).some(w => hasWord(e.text, w)))) {
        found.set(base, cap(base));
      }
    });

    const order = Object.keys(HEX);
    return [...found.entries()]
      .map(([value, label]) => ({ value, label, hex: hexFor(value) }))
      .sort((a, b) => {
        const ia = order.indexOf(a.value), ib = order.indexOf(b.value);
        if (ia !== -1 && ib !== -1) return ia - ib;
        if (ia !== -1) return -1;
        if (ib !== -1) return 1;
        return a.label.localeCompare(b.label, 'fr');
      });
  }

  function hasColor(entry, value) {
    const v = norm(value);
    if (entry.couleur.has(v)) return true;
    for (const opt of entry.couleur) if (hasWord(opt, v)) return true;
    return (COLOR_WORDS[v] || [v]).some(w => hasWord(entry.text, w));
  }

  function findCards() {
    const groups = new Map();
    document.querySelectorAll('a[href*="/products/"]').forEach(a => {
      const m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      if (a.closest('#mossen-empty, #mossen-status, .mossen-panel')) return;

      let node = a;
      for (let i = 0; i < 8 && node.parentElement && node.parentElement !== document.body; i++) {
        const sibs = [...node.parentElement.children]
          .filter(c => c.querySelector('a[href*="/products/"]')).length;
        if (sibs >= 3) break;
        node = node.parentElement;
      }

      const parent = node.parentElement;
      if (!parent) return;
      if (!groups.has(parent)) groups.set(parent, new Map());
      const g = groups.get(parent);
      if (!g.has(node)) { g.set(node, m[1]); seenHandles.add(m[1]); }
    });

    let best = new Map();
    groups.forEach(g => { if (g.size > best.size) best = g; });
    return best;
  }

  let watchTimer = null;
  let observer = null;
  let observing = false;
  const seenHandles = new Set();

  const runs = [];
  function runawayDetected() {
    const now = Date.now();
    runs.push(now);
    while (runs.length && now - runs[0] > 10000) runs.shift();
    return runs.length > 8;
  }

  function startObserving() {
    if (!observer || observing) return;
    observer.observe(document.body, { childList: true, subtree: true });
    observing = true;
  }

  function stopObserving() {
    if (!observer || !observing) return;
    observer.disconnect();
    observing = false;
  }

  function watchGrid() {
    if (observer || !window.MutationObserver) return;

    observer = new MutationObserver(muts => {
      let fresh = false;
      for (const m of muts) {
        for (const n of m.addedNodes) {
          if (n.nodeType !== 1) continue;
          if (n.closest && n.closest('#mossen-empty, #mossen-status, .mossen-panel')) continue;
          const links = n.matches && n.matches('a[href*="/products/"]')
            ? [n]
            : (n.querySelectorAll ? [...n.querySelectorAll('a[href*="/products/"]')] : []);
          for (const a of links) {
            const h = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
            if (h && !seenHandles.has(h[1])) { fresh = true; break; }
          }
          if (fresh) break;
        }
        if (fresh) break;
      }
      if (!fresh) return;

      if (runawayDetected()) {
        stopObserving();
        console.warn('[Mossen] Filtrage : rythme anormal détecté, surveillance suspendue.');
        return;
      }

      clearTimeout(watchTimer);
      watchTimer = setTimeout(applyFilters, 300);
    });

    startObserving();
  }

  function priceBounds(data) {
    const all = Object.values(data).filter(e => e.pmax > 0);
    if (!all.length) return { min: 0, max: 500 };
    return {
      min: Math.floor(Math.min(...all.map(e => e.pmin))),
      max: Math.ceil(Math.max(...all.map(e => e.pmax)))
    };
  }

  function matches(entry, sel) {
    if (!entry) return false;
    if (sel.price) {
      const [lo, hi] = sel.price.split('-').map(Number);
      if (!(entry.pmax >= lo && entry.pmin <= hi)) return false;
    }
    if (sel.colors && !hasColor(entry, sel.colors)) return false;
    return true;
  }

  function gridLeft(cards) {
    const lefts = [...cards.keys()]
      .map(el => el.getBoundingClientRect().left)
      .filter(v => v > -1000);
    return lefts.length ? Math.min(...lefts) : 0;
  }

  function padFor(el, target) {
    const own = el.getBoundingClientRect().left;
    const min = window.innerWidth < 750 ? 18 : 40;
    const pad = Math.max(target - own, min);
    el.style.paddingLeft = pad + 'px';
    el.style.paddingRight = pad + 'px';
  }

  async function applyFilters() {
    const wasObserving = observing;
    stopObserving();
    try {
      await runFilters();
    } finally {
      if (wasObserving) setTimeout(startObserving, 0);
    }
  }

  async function runFilters() {
    const p = new URLSearchParams(window.location.search);
    const sel = {
      colors: p.get(PARAMS.colors) || '',
      price:  p.get(PARAMS.price)  || ''
    };
    const cards = findCards();
    const left = gridLeft(cards);
    const active = sel.colors || sel.price;

    if (!active) {
      cards.forEach((h, el) => { el.style.removeProperty('display'); });
      renderStatus(null, 0, left);
      renderEmpty(null);
      return;
    }

    const data = await loadCatalogue();
    let shown = 0;
    cards.forEach((handle, el) => {
      const ok = matches(data[handle], sel);
      el.style.display = ok ? '' : 'none';
      if (ok) shown++;
    });
    renderStatus(sel, shown, left);
    renderEmpty(shown === 0 ? sel : null, left);
  }

  function chipLabel(key, value) {
    if (key !== 'price') return value;
    const [lo, hi] = value.split('-');
    return lo + ' € – ' + hi + ' €';
  }

  function renderStatus(sel, count, left) {
    const prev = document.getElementById('mossen-status');
    if (prev) prev.remove();
    if (!sel) return;

    const bar = document.getElementById('mossen-filter-pills');
    if (!bar) return;

    const chips = Object.keys(PARAMS)
      .filter(k => sel[k])
      .map(k => `<button class="mossen-chip" data-key="${k}">${chipLabel(k, sel[k])}<i></i></button>`)
      .join('');

    const status = document.createElement('div');
    status.id = 'mossen-status';
    status.className = 'mossen-status';
    status.innerHTML = count > 0
      ? `<span class="mossen-status__count">${count} article${count > 1 ? 's' : ''}</span>${chips}`
      : chips;
    bar.parentNode.insertBefore(status, bar.nextSibling);
    padFor(status, left);

    status.querySelectorAll('.mossen-chip').forEach(b => {
      b.addEventListener('click', () => {
        const p = new URLSearchParams(window.location.search);
        p.delete(PARAMS[b.dataset.key]);
        history.replaceState(null, '', window.location.pathname + (p.toString() ? '?' + p : ''));
        applyFilters();
      });
    });
  }

  const REPORT_TO = ['sav@maisonmossen.com', 'maisonmossen@gmail.com'];
  const REPORT_ENDPOINT = '';

  const REPORT_REASONS = [
    'Des articles correspondants existent mais ne remontent pas',
    'La matière annoncée sur la fiche produit est erronée',
    'Une couleur manque dans la liste',
    'Autre'
  ];

  function renderEmpty(sel, left) {
    const prev = document.getElementById('mossen-empty');
    if (prev) prev.remove();
    if (!sel) return;

    const status = document.getElementById('mossen-status');
    if (!status) return;

    const criteria = Object.keys(PARAMS).filter(k => sel[k])
      .map(k => LABELS[k] + ' : ' + chipLabel(k, sel[k])).join(' · ');

    const box = document.createElement('div');
    box.id = 'mossen-empty';
    box.className = 'mossen-empty';
    box.innerHTML = `
      <p class="mossen-empty__title">Malheureusement, aucun résultat n'a été trouvé pour ce filtre.</p>
      <p class="mossen-empty__sub">Veuillez essayer un autre filtre.</p>

      <div class="mossen-report">
        <div class="mossen-report__head">
          <div>
            <p class="mossen-report__title">Aidez-nous à améliorer l'expérience client</p>
            <p class="mossen-report__sub">Signaler un problème</p>
          </div>
          <button class="mossen-report__toggle" type="button">Signaler</button>
        </div>

        <div class="mossen-report__body" hidden>
          <fieldset class="mossen-report__field">
            <legend>Nature du problème</legend>
            ${REPORT_REASONS.map((r, i) => `
              <label class="mossen-check">
                <input type="checkbox" value="${r}" ${i === 0 ? 'checked' : ''}>
                <span>${r}</span>
              </label>`).join('')}
          </fieldset>

          <div class="mossen-report__field">
            <label class="mossen-lbl" for="mossen-report-mail">Votre e-mail</label>
            <input class="mossen-input" id="mossen-report-mail" type="email" required placeholder="prenom@exemple.com">
          </div>

          <div class="mossen-report__field">
            <label class="mossen-lbl" for="mossen-report-msg">Précisions</label>
            <textarea class="mossen-input mossen-textarea" id="mossen-report-msg" rows="4"
              placeholder="Décrivez ce que vous cherchiez…"></textarea>
          </div>

          <button class="mossen-report__send" type="button">Envoyer le signalement</button>
          <p class="mossen-report__note" hidden></p>
        </div>
      </div>
    `;
    status.parentNode.insertBefore(box, status.nextSibling);
    padFor(box, left);

    const body   = box.querySelector('.mossen-report__body');
    const toggle = box.querySelector('.mossen-report__toggle');
    const note   = box.querySelector('.mossen-report__note');

    toggle.addEventListener('click', () => {
      body.hidden = !body.hidden;
      toggle.textContent = body.hidden ? 'Signaler' : 'Annuler';
    });

    box.querySelector('.mossen-report__send').addEventListener('click', async () => {
      const mail = box.querySelector('#mossen-report-mail').value.trim();
      const msg  = box.querySelector('#mossen-report-msg').value.trim();
      const reasons = [...box.querySelectorAll('.mossen-check input:checked')].map(i => i.value);

      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail)) {
        note.hidden = false;
        note.textContent = 'Merci d\'indiquer une adresse e-mail valide.';
        return;
      }

      const lines = [
        'Signalement — filtres de collection',
        'Destinataires : ' + REPORT_TO.join(', '),
        '',
        'Filtre actif : ' + (criteria || '—'),
        'Page : ' + window.location.href,
        '',
        'Nature du problème :',
        ...reasons.map(r => '  - ' + r),
        '',
        'Précisions :',
        msg || '—'
      ].join('\n');

      note.hidden = false;
      note.textContent = 'Envoi en cours…';

      try {
        if (REPORT_ENDPOINT) {
          const r = await fetch(REPORT_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              email: mail,
              to: REPORT_TO,
              subject: 'Signalement filtres — ' + (criteria || 'collection'),
              message: lines
            })
          });
          if (!r.ok) throw new Error();
        } else {
          const fd = new FormData();
          fd.append('form_type', 'contact');
          fd.append('utf8', '✓');
          fd.append('contact[email]', mail);
          fd.append('contact[body]', lines);
          const r = await fetch('/contact', { method: 'POST', body: fd });
          if (!r.ok) throw new Error();
        }
        body.innerHTML = '<p class="mossen-report__done">Merci, votre signalement a bien été transmis.</p>';
      } catch (e) {
        const subject = encodeURIComponent('Signalement filtres — ' + (criteria || 'collection'));
        note.innerHTML = 'L\'envoi a échoué. <a href="mailto:' + REPORT_TO.join(',') + '?subject='
          + subject + '&body=' + encodeURIComponent(lines) + '">Écrire directement au service client</a>.';
      }
    });
  }

  /* ---------- Injection de la barre ---------- */
  function injectPills() {
    if (document.getElementById('mossen-filter-pills')) return;

    const isDesktop = window.innerWidth >= 750;
    const resultsList = document.querySelector('results-list') || document.getElementById('ResultsList');

    const target = isDesktop && resultsList
      ? resultsList
      : (document.querySelector('.facets-toggle') ||
         document.querySelector('.facets-toggle__wrapper') ||
         document.querySelector('.facets-mobile-wrapper') ||
         document.querySelector('.collection-filter-and-sort'));

    if (!target) { setTimeout(injectPills, 300); return; }

    const FILTER_HANDLES = ['fabrication-artisanale', 'fabrique-en-europe'];

    const collectionPath =
      (window.location.pathname.match(/^\/collections\/[^/]+/) || [window.location.pathname])[0];
    const handle = collectionPath.split('/collections/')[1] || '';

    let originPath = collectionPath;
    try {
      if (FILTER_HANDLES.includes(handle)) {
        originPath = sessionStorage.getItem('mossen:origin-collection') || collectionPath;
      } else {
        sessionStorage.setItem('mossen:origin-collection', collectionPath);
      }
    } catch (e) { /* navigation privée */ }

    const pills = document.createElement('div');
    pills.id = 'mossen-filter-pills';
    pills.className = 'mossen-filter-pills';

    pills.innerHTML = `
      <div class="mossen-pills-left">
        <a href="${originPath}" class="mossen-filter-pill">Tendances</a>
        <a href="/collections/fabrication-artisanale" class="mossen-filter-pill">Atelier français</a>
        <a href="/collections/fabrique-en-europe" class="mossen-filter-pill">Fabriqué en Italie</a>
      </div>
      <div class="mossen-pills-right">
        <button class="mossen-filter-pill mossen-pill-toggle" data-menu="colors">Couleurs<i class="mossen-caret"></i></button>
        <button class="mossen-filter-pill mossen-pill-toggle" data-menu="price">Prix<i class="mossen-caret"></i></button>
      </div>
    `;

    if (isDesktop && resultsList) target.insertBefore(pills, target.firstElementChild);
    else target.parentNode.insertBefore(pills, target);

    pills.querySelectorAll('.mossen-pill-toggle').forEach(btn => {
      btn.addEventListener('click', e => { e.stopPropagation(); togglePanel(btn.dataset.menu, btn); });
    });
  }

  function buildContent(type) {
    const params = new URLSearchParams(window.location.search);
    const current = (params.get(PARAMS[type]) || '').toLowerCase();

    if (type === 'price') {
      const cur = (params.get(PARAMS.price) || '').split('-');
      return `<div class="mossen-price" data-lo="${cur[0] || ''}" data-hi="${cur[1] || ''}">
          <div class="mossen-price__values">
            <span id="mossen-price-lo">—</span>
            <span id="mossen-price-hi">—</span>
          </div>
          <div class="mossen-price__track">
            <div class="mossen-price__fill" id="mossen-price-fill"></div>
            <input type="range" id="mossen-price-min" min="0" max="500" value="0" step="1">
            <input type="range" id="mossen-price-max" min="0" max="500" value="500" step="1">
          </div>
        </div>`;
    }

    if (type === 'colors') {
      return '<div class="mossen-colors" data-current="' + current +
             '"><p class="mossen-note">Lecture des couleurs de la collection…</p></div>';
    }
  }

  let openType = null;

  function closePanel(instant) {
    const panel = document.getElementById('mossen-panel');
    const backdrop = document.getElementById('mossen-backdrop');
    document.querySelectorAll('.mossen-pill-toggle.is-open').forEach(b => b.classList.remove('is-open'));
    openType = null;
    window.removeEventListener('resize', reposition);
    window.removeEventListener('scroll', reposition, true);

    if (!panel && !backdrop) return;
    if (instant) { if (panel) panel.remove(); if (backdrop) backdrop.remove(); return; }

    if (panel) panel.classList.add('is-closing');
    if (backdrop) backdrop.classList.add('is-closing');
    setTimeout(() => { if (panel) panel.remove(); if (backdrop) backdrop.remove(); }, 240);
  }

  function rowAboveTop(barTop) {
    if (barTop < 8) return null;

    const masked = [];
    ['mossen-panel', 'mossen-backdrop'].forEach(id => {
      const el = document.getElementById(id);
      if (el) { masked.push([el, el.style.pointerEvents]); el.style.pointerEvents = 'none'; }
    });

    const probe = document.elementFromPoint(30, Math.max(1, barTop - 6));

    masked.forEach(([el, v]) => { el.style.pointerEvents = v; });
    if (!probe) return null;

    let best = null, node = probe;
    for (let i = 0; i < 6 && node && node !== document.body; i++) {
      const r = node.getBoundingClientRect();
      if (r.width >= window.innerWidth * 0.9 && r.height > 10 && r.height < 220) best = node;
      node = node.parentElement;
    }
    if (!best) return null;

    const top = best.getBoundingClientRect().top;
    if (top >= barTop || barTop - top > 300) return null;
    return top;
  }

  function anchorTop() {
    if (window.MOSSEN_ANCHOR) {
      const el = document.querySelector(window.MOSSEN_ANCHOR);
      if (el) {
        const r = el.getBoundingClientRect();
        if (r.height > 0) return r.bottom;
      }
    }

    const bar = document.getElementById('mossen-filter-pills');
    if (!bar) return 0;

    const barTop = bar.getBoundingClientRect().top;

    if (barTop < 0) {
      let stickyBottom = 0;
      document.querySelectorAll('header, sticky-header, [class*="header"]').forEach(el => {
        const pos = getComputedStyle(el).position;
        if (pos !== 'fixed' && pos !== 'sticky') return;
        const r = el.getBoundingClientRect();
        if (r.top <= 4 && r.height > 20 && r.width > window.innerWidth * 0.8) {
          stickyBottom = Math.max(stickyBottom, r.bottom);
        }
      });
      return stickyBottom;
    }

    const above = rowAboveTop(barTop);
    return above !== null ? above : barTop;
  }

  function reposition() {
    const panel = document.getElementById('mossen-panel');
    if (!panel) return;
    const top = Math.max(0, anchorTop());
    panel.style.top = top + 'px';

    const inner = panel.querySelector('.mossen-panel__inner');
    const footer = panel.querySelector('.mossen-panel__footer');
    const footerH = footer ? footer.offsetHeight : 0;
    const room = window.innerHeight - top - footerH - 24;
    const cap = window.innerWidth < 750 ? window.innerHeight * 0.46 : window.innerHeight * 0.52;
    inner.style.maxHeight = Math.max(140, Math.min(room, cap)) + 'px';
  }

  function bindOptions(panel, sel) {
    panel.querySelectorAll(sel).forEach(el => {
      el.addEventListener('click', () => {
        const wasActive = el.classList.contains('active');
        panel.querySelectorAll(sel).forEach(x => x.classList.remove('active'));
        if (!wasActive) el.classList.add('active');
      });
    });
  }

  async function fillColors(panel) {
    const host = panel.querySelector('.mossen-colors');
    if (!host) return;
    const current = host.dataset.current || '';

    const data = await loadCatalogue();
    const list = availableColors(data);

    if (!list.length) {
      host.innerHTML = '<p class="mossen-note">Aucune couleur identifiée dans cette collection.</p>';
      return;
    }

    host.innerHTML = list.map(c => {
      const known = c.hex !== null;
      const bg = known ? c.hex : '#EFEFEF';
      const ring = (!known || c.hex === '#FFFFFF')
        ? 'box-shadow:0 0 0 1px rgba(0,0,0,.16);' : '';
      return `<div class="mossen-color ${current === c.value ? 'active' : ''}" data-value="${c.value}">
                <div class="mossen-color__dot" style="background:${bg};${ring}"></div>
                <div class="mossen-color__name">${c.label}</div>
              </div>`;
    }).join('');
  }

  function setupPriceSlider(panel) {
    const wrap = panel.querySelector('.mossen-price');
    const lo   = panel.querySelector('#mossen-price-min');
    const hi   = panel.querySelector('#mossen-price-max');
    const fill = panel.querySelector('#mossen-price-fill');
    const labLo = panel.querySelector('#mossen-price-lo');
    const labHi = panel.querySelector('#mossen-price-hi');

    let bounds = { min: 0, max: 500 };

    function redraw() {
      const span = bounds.max - bounds.min || 1;
      const a = ((+lo.value - bounds.min) / span) * 100;
      const b = ((+hi.value - bounds.min) / span) * 100;
      fill.style.left  = a + '%';
      fill.style.right = (100 - b) + '%';
      labLo.textContent = lo.value + ' €';
      labHi.textContent = hi.value + ' €';
    }

    lo.addEventListener('input', () => {
      if (+lo.value > +hi.value - 1) lo.value = +hi.value - 1;
      redraw();
    });
    hi.addEventListener('input', () => {
      if (+hi.value < +lo.value + 1) hi.value = +lo.value + 1;
      redraw();
    });

    loadCatalogue().then(data => {
      bounds = priceBounds(data);
      lo.min = hi.min = bounds.min;
      lo.max = hi.max = bounds.max;
      lo.value = wrap.dataset.lo !== '' ? wrap.dataset.lo : bounds.min;
      hi.value = wrap.dataset.hi !== '' ? wrap.dataset.hi : bounds.max;
      redraw();
    });

    return {
      reset() { lo.value = bounds.min; hi.value = bounds.max; redraw(); },
      value() {
        const a = +lo.value, b = +hi.value;
        return (a > bounds.min || b < bounds.max) ? a + '-' + b : '';
      }
    };
  }

  function togglePanel(type, btn) {
    if (openType === type) { closePanel(); return; }
    closePanel(true);
    openType = type;
    btn.classList.add('is-open');

    const backdrop = document.createElement('div');
    backdrop.id = 'mossen-backdrop';
    backdrop.addEventListener('click', () => closePanel());
    document.body.appendChild(backdrop);

    const panel = document.createElement('div');
    panel.id = 'mossen-panel';
    panel.className = 'mossen-panel';
    panel.innerHTML = `
      <div class="mossen-panel__inner">
        <div class="mossen-panel__head">
          <p class="mossen-panel__label">${LABELS[type]}</p>
          <button class="mossen-panel__close" aria-label="Fermer"></button>
        </div>
        ${buildContent(type)}
      </div>
      <div class="mossen-panel__footer">
        <button class="mossen-reset">Tout effacer</button>
        <button class="mossen-apply">Voir les résultats</button>
      </div>
    `;
    panel.addEventListener('click', e => e.stopPropagation());
    document.body.appendChild(panel);

    panel.querySelector('.mossen-panel__close').addEventListener('click', () => closePanel());

    reposition();
    window.addEventListener('resize', reposition);
    window.addEventListener('scroll', reposition, true);

    let priceApi = null;
    if (type === 'price') {
      priceApi = setupPriceSlider(panel);
    } else if (type === 'colors') {
      fillColors(panel).then(() => bindOptions(panel, '.mossen-color'));
    }

    panel.querySelector('.mossen-reset').addEventListener('click', () => {
      if (priceApi) priceApi.reset();
      else panel.querySelectorAll('.mossen-color')
                .forEach(x => x.classList.remove('active'));
    });

    panel.querySelector('.mossen-apply').addEventListener('click', () => {
      const p = new URLSearchParams(window.location.search);

      if (priceApi) {
        const v = priceApi.value();
        if (v) p.set(PARAMS.price, v); else p.delete(PARAMS.price);
      } else {
        const sel = '.mossen-color';
        const active = panel.querySelector(sel + '.active');
        if (active) p.set(PARAMS[type], active.dataset.value);
        else p.delete(PARAMS[type]);
      }

      history.replaceState(null, '', window.location.pathname + (p.toString() ? '?' + p : ''));
      closePanel();
      applyFilters();
    });
  }

  document.addEventListener('click', () => closePanel());
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closePanel(); });

  function start() {
    injectPills();
    setTimeout(() => { applyFilters(); watchGrid(); }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(start, 100));
  } else {
    setTimeout(start, 100);
  }
})();